import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  TableSortLabel, Grid
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import {DropzoneArea} from "material-ui-dropzone";
import {postTipCreationAPIReq} from "../../../../utils/requests";
import validate from "validate.js";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const statusColors = {
  delivered: 'success',
  pending: 'info',
  refunded: 'danger'
};

const TipsTable = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [image, setImage] = React.useState([]);
  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      title: "",
      description: ""
    },
    touched: {},
    errors: {}
  });

  const handleNewEntryOpen = () => {
    setOpen(true);
  };

  const handleChange = (event) => {
    event.persist();

    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,+*%!?-]*$/)) {
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      }));
    }

  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCreation = (event) => {
    event.preventDefault();
    return postTipCreationAPIReq(formState.values, image)
      .then(res=>{
        if (res.error) {
          alert('An arror has occured')
          handleClose()
        } else {
          handleClose()
        }
      }).catch((err) => {
        console.error(err)
        handleClose()
      })
  };

  const schema = {
    title: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 64
      }
    },
    description: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 500
      }
    }
  };


  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const onPictureFileChange = (files) => {
    setImage(files[0])
  };
  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={
          <Button
            color="primary"
            size="small"
            variant="outlined"
            onClick={()=>{handleNewEntryOpen()}}
          >
            New entry
          </Button>
        }
        title="Career Tips Table"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Poster</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Is Targeted</TableCell>
                  <TableCell sortDirection="desc">
                    <Tooltip
                      enterDelay={300}
                      title="Sort"
                    >
                      <TableSortLabel
                        active
                        direction="desc"
                      >
                        Created
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>

                  <TableCell>System ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data.map(tip => (
                  <TableRow
                    hover
                    key={tip.hashed_id}
                  >
                    <TableCell><img src={tip.picture}  style={{height: 50, width: 70}}/></TableCell>
                    <TableCell>{tip.title}</TableCell>
                    <TableCell>{tip.description}</TableCell>
                    <TableCell>{tip.isTargeted?"Yes":"No"}</TableCell>
                    <TableCell>
                      {moment(tip.createdAt).format('DD/MM/YYYY')}
                    </TableCell>

                    <TableCell>{tip.hashed_id}</TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          View all <ArrowRightIcon />
        </Button>
      </CardActions>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Career Tip Creation</DialogTitle>
        <DialogContent>
          <TextField
            style={{marginBottom:20}}
            autoFocus
            margin="dense"
            id="title"
            name="title"
            label="Title"
            type="text"
            onChange={handleChange}
            error={hasError('name')}
            helperText={
              hasError('name') ? formState.errors.name[0] : null
            }
            fullWidth
          />
          <TextField
            style={{marginBottom:50}}
            autoFocus
            margin="dense"
            name="description"
            id="description"
            label="Details"
            type="text"
            onChange={handleChange}
            error={hasError('name')}
            helperText={
              hasError('name') ? formState.errors.name[0] : null
            }
            fullWidth
            multiline="true"
            rows={4}
          />
          <DropzoneArea
            onChange={onPictureFileChange}
            filesLimit={1}
            dropzoneText="Drop a Banner/Poster"
            showPreviewsInDropzone={true}
            acceptedFiles={['image/jpeg', 'image/png']}
            name="image"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='gray' >
            Cancel
          </Button>
          <Button onClick={handleCreation} disabled={!formState.isValid} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

TipsTable.propTypes = {
  className: PropTypes.string
};

export default TipsTable;
